import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import auth from "./../../../store/modules/auth";
import publishing from "./modules/publishing";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    publishing
  },

  state: {
    config: null,
    errors: null,
    isReady: false,
    unauthorized: false
  },

  getters: {
    hasSubscription(state) {
      return state.config.subscription.enabled;
    },

    logo(state) {
      return state.config.ui.logo;
    },

    isNotProduction(state) {
      return state.config.app.environment.toLowerCase() != 'production'
    },

    kytebaseBaseURl(state) {
      return state.config.kytebase.base_url;
    },

    kytebaseMediaUploadUrl(state) {
      return `${state.config.kytebase.base_url}/admin/api/media/upload`;
    }
  },

  mutations: {
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },

    UNSET_ERRORS(state) {
      state.errors = null;
    },

    SET_CONFIG(state, data) {
      state.config = data;
    },

    initialized(state) {
      state.isReady = true;
    },

    unauthorized(state) {
      state.unauthorized = true;
    }
  },

  actions: {
    notifyErrors({ commit }, errors) {
      commit("SET_ERRORS", errors);
      setTimeout(() => commit("UNSET_ERRORS"), 8000);
    },

    async initAdminPanel({ commit }) {
      let response = await axios.get("/admin/api/panel/init");
      commit("SET_CONFIG", response.data);
      commit("initialized");

      document.getElementsByTagName('title')[0].textContent = 'Admin - ' + response.data.app.name
      document.getElementsByClassName('loading-container')[0].style.display = 'none'
    },

    showUnauthorizedError({ commit }) {
      commit("unauthorized")
      document.getElementsByClassName('loading-container')[0].style.display = 'none'
    }
  }
});
